import { DeviceTypesEnum } from "../../common/enums/DeviceTypesEnum";
import { ObjectFeaturesEnum } from "../../common/enums/ObjectFeaturesEnum";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IEntityValueDeviceModel, IEntityValueTankModel, IEntityValueWellModel } from "../../common/models/IEntityValueModels";
import { ITankBattery } from "../../common/models/ITankBattery";
import { ITankStyle } from "../../common/models/TankStyle";
import TagValueDataService from "../../services/tag-value-data-service/TagValueDataService";


const TankBatteryTagValueUtils = {

    getData: async function(customerID: number,
        contextGroupID: number, 
        eLynxObject: IeLynxObject,
        offline: boolean, 
        useLKVOffline: boolean,
        signal: AbortSignal): Promise<IEntityValueDeviceModel | IEntityValueTankModel | IEntityValueWellModel | ITankBattery | undefined> {
        return TagValueDataService.getTagValueData(customerID, contextGroupID, eLynxObject, undefined, offline, useLKVOffline, undefined, signal);
    },
    shapeTankData: function(tankBattery: ITankBattery): IEntityValueTankModel[] {

        let returnData= tankBattery.tanks.map((o) => {
            const item: IEntityValueTankModel = {
                id: o.id,
                objectType: o.objectType,
                objectName: o.objectName,
                displayText: o.displayText,
                tags: [...o.tags],
                deviceType: DeviceTypesEnum.InternalTank,
                subTypeID: o.subTypeID as number,
                tankStyle: tankBattery.tankStyles.find(v => v.id === o.tankStyleID) as ITankStyle,
                features: ObjectFeaturesEnum.ManualEntry,   //???
                lookupLists: [],
                categories: [],
                tanks: []
            };
            return item;
        });

        return returnData;
    }

};

export default TankBatteryTagValueUtils;
